// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"Form_formContainer__3UDAH","img1":"Form_img1__Xo0qo","img2":"Form_img2__28Bbq"};